module.exports = __webpack_public_path__ + "img/horizontal_7_1_pp1_9006.c79985b7.png";